export const GET_MODULES_BY_ROLE_ID_REQUEST = "GET_MODULES_BY_ROLE_ID_REQUEST";
export const GET_MODULES_BY_ROLE_ID_SUCCESS = "GET_MODULES_BY_ROLE_ID_SUCCESS";
export const GET_MODULES_BY_ROLE_ID_FAILURE = "GET_MODULES_BY_ROLE_ID_FAILURE";

export const GET_SUB_MODULES_BY_ROLE_ID_REQUEST = "GET_SUB_MODULES_BY_ROLE_ID_REQUEST";
export const GET_SUB_MODULES_BY_ROLE_ID_SUCCESS = "GET_SUB_MODULES_BY_ROLE_ID_SUCCESS";
export const GET_SUB_MODULES_BY_ROLE_ID_FAILURE = "GET_SUB_MODULES_BY_ROLE_ID_FAILURE";

